import React from "react";

interface PaziaTableDownloadIconProps {
  onClick?: (e: React.MouseEvent<SVGSVGElement>) => void;
  className?: string;
}

export const DownloadIcon = ({ onClick, className = "" }: PaziaTableDownloadIconProps) => {
  return (
    <svg className={`w-8 h-8 fill-current ${className}`} viewBox="0 0 32 32" onClick={onClick}>
      <path d="M16 20c.3 0 .5-.1.7-.3l5.7-5.7-1.4-1.4-4 4V8h-2v8.6l-4-4L9.6 14l5.7 5.7c.2.2.4.3.7.3zM9 22h14v2H9z"></path>
    </svg>
  );
};
